module.exports = __webpack_public_path__ + "static/media/logo-cihm-white.a1481aff.png";